import React from "react";
import styled from "styled-components";
import { useAuth } from "../../contexts/AuthContext";
import Card from "../UI/Card";

const ScriptsContainer = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
`;

const TableContainer = styled.div`
  overflow-x: auto;
  margin-top: 1.5rem;
`;

const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;

  th,
  td {
    padding: 1rem;
    text-align: left;
    border-bottom: 1px solid var(--border-color);
  }

  th {
    background-color: var(--background-tertiary);
    color: var(--primary-color);
    font-weight: 600;
    text-transform: uppercase;
    font-size: 0.85rem;
    letter-spacing: 1px;
  }

  tr:hover td {
    background-color: rgba(212, 175, 55, 0.05);
  }

  td {
    color: var(--text-secondary);
  }
`;

const WelcomeText = styled.div`
  margin-bottom: 2rem;

  h2 {
    margin-bottom: 0.5rem;
    font-family: "Playfair Display", serif;
  }

  p {
    color: var(--text-secondary);
  }
`;

const EmptyState = styled.div`
  text-align: center;
  padding: 3rem;
  color: var(--text-tertiary);
`;

const ScriptsPage = () => {
  const { currentUser } = useAuth();

  // Placeholder data for scripts table
  const scripts = [
    {
      id: 1,
      name: "Instagram Story",
      platform: "Instagram",
      status: "Completed",
      date: "2023-06-15",
    },
    {
      id: 2,
      name: "TikTok Viral",
      platform: "TikTok",
      status: "In Progress",
      date: "2023-06-18",
    },
    {
      id: 3,
      name: "YouTube Intro",
      platform: "YouTube",
      status: "Pending",
      date: "2023-06-20",
    },
  ];

  return (
    <ScriptsContainer>
      <WelcomeText>
        <h2>Your Scripts</h2>
        <p>
          Welcome, {currentUser?.displayName || currentUser?.email}! Here are
          your generated scripts.
        </p>
      </WelcomeText>

      <Card>
        <Card.Body>
          {scripts.length > 0 ? (
            <TableContainer>
              <StyledTable>
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Platform</th>
                    <th>Status</th>
                    <th>Date</th>
                  </tr>
                </thead>
                <tbody>
                  {scripts.map((script) => (
                    <tr key={script.id}>
                      <td>{script.name}</td>
                      <td>{script.platform}</td>
                      <td>{script.status}</td>
                      <td>{script.date}</td>
                    </tr>
                  ))}
                </tbody>
              </StyledTable>
            </TableContainer>
          ) : (
            <EmptyState>
              <p>No scripts found. Create your first script now!</p>
            </EmptyState>
          )}
        </Card.Body>
      </Card>
    </ScriptsContainer>
  );
};

export default ScriptsPage;
